import { Component, OnInit, ViewEncapsulation, HostBinding, Input, Output, EventEmitter } from '@angular/core';
import { IdService } from '../../../shared/services/id.service';
import { Locale } from '../datatable.models';
import { IDatatableGlobalSearchEvent } from './datatable-global-searcher.type';

@Component({
	selector: 'rbc-datatable-global-searcher',
	templateUrl: './datatable-global-searcher.component.html',
	styleUrls: ['./datatable-global-searcher.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class DatatableGlobalSearcherComponent implements OnInit {
	@HostBinding('class') @Input('class') classList: string = '';
	@Input() id: string;
	@Input() locale: Locale;
	@Input() globalSearchTerm: string = '';

	@Output('onglobalsearchfocusout') onGlobalSearchFocusout = new EventEmitter<IDatatableGlobalSearchEvent>();
	@Output('onglobalsearchtermupdate') onGlobalSearchTermUpdate = new EventEmitter<IDatatableGlobalSearchEvent>();

	constructor(private idService: IdService) {}

	ngOnInit() {
		if (!this.id) {
			this.id = this.idService.generate();
		}
		if (!this.globalSearchTerm) {
			this.globalSearchTerm = '';
		}
		this.classList = [this.classList, 'datatable-globalsearcher'].filter(i => !!i).join(' ');
	}

	focusOut(newTerm: string) {
		this.onGlobalSearchFocusout.emit({
			value: newTerm ? newTerm : ''
		});
	}
	inputUpdate(newInput: string) {
		this.onGlobalSearchTermUpdate.emit({
			value: newInput ? newInput : ''
		});
	}
	reset() {
		this.globalSearchTerm = '';
		this.onGlobalSearchTermUpdate.emit({
			value: ''
		});
	}
}
